import React from 'react';
import { FadeIn } from './FadeIn';
export function Achievements() {
  const achievements = [{
    emoji: '📖',
    text: <>
          Pasarás de improvisar con materiales sueltos a tener un{' '}
          <span className="bg-kid-yellow/10 px-1 rounded" data-id="element-24">proceso claro</span>{' '}
          para acompañar a tu hijo.
        </>,
    bg: 'bg-kid-purple/10',
    border: 'border-kid-purple/20'
  }, {
    emoji: '🧠',
    text: <>
          Comprenderás cómo aprende realmente el{' '}
          <span className="bg-kid-yellow/10 px-1 rounded" data-id="element-25">
            cerebro infantil
          </span>{' '}
          al iniciarse en la lectura.
        </>,
    bg: 'bg-kid-pink/10',
    border: 'border-kid-pink/20'
  }, {
    emoji: '🎯',
    text: <>
          Ayudarás a tu hijo a{' '}
          <span className="bg-kid-yellow/10 px-1 rounded" data-id="element-26">
            reducir frustración y ganar seguridad
          </span>{' '}
          al practicar.
        </>,
    bg: 'bg-kid-sky/10',
    border: 'border-kid-sky/20'
  }, {
    emoji: '⚡',
    text: <>
          Tendrás una rutina simple de{' '}
          <span className="bg-kid-yellow/10 px-1 rounded" data-id="element-27">
            10 minutos diarios
          </span>{' '}
          que organiza el aprendizaje.
        </>,
    bg: 'bg-kid-yellow/10',
    border: 'border-kid-yellow/20'
  }, {
    emoji: '📚',
    text: <>
          Contarás con un sistema que conecta{' '}
          <span className="bg-kid-yellow/10 px-1 rounded" data-id="element-28">
            sonido, trazo y palabra
          </span>{' '}
          de forma natural.
        </>,
    bg: 'bg-kid-lime/10',
    border: 'border-kid-lime/20'
  }];
  return <section className="py-8 md:py-20 px-4 bg-gradient-to-br from-kid-lime/5 via-kid-yellow/5 to-white relative overflow-hidden" data-id="element-29">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-30">
        <FadeIn data-id="element-31">
          <div className="text-center mb-6 md:mb-12" data-id="element-32">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 md:mb-6" data-id="element-33">
              QUÉ LOGRARÁS CON ESTE SISTEMA
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-kid-lime to-kid-yellow mx-auto rounded-full" data-id="element-34"></div>
          </div>
        </FadeIn>

        <div className="w-full" data-id="element-35">
          <div className="space-y-3" data-id="element-36">
            {achievements.map((item, idx) => <FadeIn key={idx} delay={idx * 0.08} data-id="element-37">
                <div className="flex items-center gap-4 md:gap-5 p-4 md:p-5 rounded-xl bg-white border border-gray-200 shadow-sm" data-id="element-38">
                  <div className={`w-11 h-11 md:w-12 md:h-12 rounded-xl ${item.bg} border ${item.border} flex items-center justify-center flex-shrink-0 text-2xl md:text-3xl`} data-id="element-39">
                    {item.emoji}
                  </div>
                  <p className="text-gray-700 font-medium text-sm md:text-base leading-snug md:leading-relaxed" data-id="element-40">
                    {item.text}
                  </p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}